import React from "react"
import {
    IPunchSetDocument,
    ITimecardDay,
    ITimecardEmployee
} from "../../models"
import autobind from "class-autobind"
import EmployeeTimecardTablePSCellChildrenList from "./EmployeeTimecardTablePSCellChildrenList"

interface IProps {
    childPunchSets: IPunchSetDocument[]
    timecardDay: ITimecardDay
    user: ITimecardEmployee
    fullPunchSets: IPunchSetDocument[]
    showTimecardDetails: boolean
}
interface IState {
    expanded: boolean
}

export default class EmployeeTimecardTablePSCellChildren extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            expanded: false
        }
        autobind(this)
    }

    render() {
        
        const header = (<span style={{cursor: "pointer"}} onClick={()=>{
            this.setState({expanded: !this.state.expanded})
        }}>
            {this.state.expanded 
                ? 
                    <span><i className="fa-regular fa-square-minus" /> HIDE DETAILS</span> 
                : 
                    <span><i className="fa-regular fa-square-plus" /> TIME DETAILS</span>
            }
        </span>)

        const borderStyle = {
            borderLeft: "solid 2px #efefef", 
            borderBottom: "solid 2px #efefef", 
            paddingBottom: 10,
            paddingTop: 10, 
            paddingLeft: 5,
            borderBottomLeftRadius: 20,
        }

        return this.props.childPunchSets.length > 0 ? (
            <div style={{marginLeft: 20}} >
                {header}
                    {this.state.expanded &&
                    <div style={borderStyle}>
                        <EmployeeTimecardTablePSCellChildrenList 
                            childPunchSets={this.props.childPunchSets} 
                            timecardDay={this.props.timecardDay} 
                            user={this.props.user} 
                            fullPunchSets={this.props.fullPunchSets} 
                            showTimecardDetails={this.props.showTimecardDetails} />
                    </div>
                    }
            </div>
        ) : (<span></span>)
    }
}
